import axios from 'axios';

type ApiErrorBody = {
    message?: string | string[];
    error?: string;
    statusCode?: number;
};

export const handlerError = (e: unknown) => {
    if (axios.isAxiosError(e)) {
        const data = e.response?.data as ApiErrorBody | undefined;

        // Nest часто отдаёт message строкой или массивом строк
        const msg =
            Array.isArray(data?.message) ? data!.message.join(', ') : data?.message;

        return (
            msg ??
            data?.error ??
            e.response?.statusText ??
            e.message
        );
    }

    if (e instanceof Error && e.message) return e.message;
    return 'неизвестная ошибка';
};
